import { Component, OnInit, OnDestroy, Input, Output, ViewChild, HostListener } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { AngularFirestore } from 'angularfire2/firestore';
import { Router, ActivatedRoute } from '@angular/router';
import { Produtos, IProdutos } from '../../../../models/produtos.model';
import { Categorias, ICategorias } from '../../../../models/categorias.model';
import { SubCategorias, ISubCategorias } from '../../../../models/subCategorias.model';
import { Subscription } from 'rxjs/Rx';
import { MatDataGridComponent } from '../../../../comum/controls/mat-datagrid';
import { IFornecedores } from '../../../../models/fornecedores.model';
import { DadosService } from '../../db/dados.service';
import { UploadImgComponent } from '../../controls/upload-Img';
import { UsersService } from '../../../../models/usuarios.service';
import { DataModelComponent } from '../../../../models/data.model.component';
import { base64 } from '@firebase/util';


function retrieveImageFromClipboardAsBlob(pasteEvent, callback) {
  if (pasteEvent.clipboardData === false) {
    if (typeof (callback) === 'function') {
      callback(undefined);
    }
  }

  const items = pasteEvent.clipboardData.items;

  if (items === undefined) {
    if (typeof (callback) === 'function') {
      callback(undefined);
    }
  }

  for (let i = 0; i < items.length; i++) {
    // Skip content if not image
    if (items[i].type.indexOf('image') === -1) { continue; }
    // Retrieve image on clipboard as blob
    const blob = items[i].getAsFile();

    if (typeof (callback) === 'function') {
      callback(blob);
    }
  }
}


let theTimer;
function countdown(proc, counter = 1, timeout = 1000) {
  /* Exit if nothing to do */
  if (counter === 0) {
    if (proc != null) { proc(); }
    return;
  }
  /* Clear @theTimer */
  clearTimeout(theTimer);

  let x = counter;

  if (x > 0) {
    theTimer = setTimeout(function () {
      countdown(proc, x, timeout);
    }, timeout);
    x--;
  }
}


@Component({
  selector: 'app-produto-lista',
  templateUrl: './produto-lista.component.html',
  styleUrls: ['./produto-lista.component.scss']
})
export class ProdutoListaComponent extends DataModelComponent<IProdutos> implements OnInit, OnDestroy {
  mensagem = '';
  editing = false;
  item: IProdutos;

  fornecedor = 0.0;
  fornecedorItem: IFornecedores = {};

  produtos: any[];
  produtosClass: Produtos;
  produtosEvent: Subscription;
  alwaysShowPaginator = true;
  form: FormGroup;
  fCategoria: number;
  categorias: ICategorias[] = [];
  categoriasExt = [];
  categoriaClass: Categorias;
  categoriaEvent: Subscription;
  @ViewChild('grid') grid: MatDataGridComponent;
  @ViewChild('upload') upload: UploadImgComponent;
  subCategorias: ISubCategorias[] = [];
  subCategClass: SubCategorias;
  subCategEvent: Subscription;
  pageIndex = 0;
  oldPageIndex = 0;


  colunas = [{ field: 'codigo', text: 'Código' },
  {
    field: 'nome', text: 'Descrição',
    fn: (x = '') => {
      if (!x) { return x; }
      if (x.length < 50) { return x; }
      return x.substring(0, 50) + '...';
    }
  },
  { field: 'unidade', text: 'Un' },
  { field: 'precoVenda', text: 'Preço Venda' },
  { field: 'categoria', text: 'Categoria' },
  ];

  getDescricao(x) {
    if (!x) { return x; }
    return x.substring(0, 50);
  }


  get categoria() {
    return this.fCategoria;
  }
  set categoria(x) {
    this.fCategoria = x;
    this.abrirProdutos();
  }

  constructor(private router: ActivatedRoute,
    private db: AngularFirestore,
    private dados: DadosService,
    private _fb: FormBuilder,
    private usersService: UsersService,
    private goRouter: Router) {
    super({});

    this.fornecedor = router.snapshot.params['fornecedor'];
    if ((this.fornecedor == null) && (usersService.usuario.fornecedor > 0)) {
      this.fornecedor = usersService.usuario.fornecedor;
    }

    // console.log('fornecedor: ', this.fornecedor);

    if ((this.fornecedor == null) || (this.fornecedor <= 0)) {
      this.goRouter.navigate(['/']);
    } else {
      // console.log('entrou para pegar fornecedor');
      this.fornecedorItem = null;
      this.dados.getFornecedor(this.fornecedor, r => {
        console.log('Fornecedor: ', r.codigo, r, this.fornecedor);
        // tslint:disable-next-line:triple-equals
        if ( Number.parseFloat(r.codigo) != this.fornecedor) { alert('Erro ao carregar os dados do fornecedor'); }
        this.fornecedorItem = r;
      });
    }
  }

  getSubPath() {
    return '/produtos/for_' + this.fornecedor;
  }


  abrirProdutos() {
    let inativo = this.produtosClass.fVerInativo;
    if (!inativo) { inativo = false; }
    if ((this.fCategoria ? this.fCategoria > 0 : false)) {
      this.produtosClass.snapshot(
        r => {
          return r.where('categoria', '==', Number(this.fCategoria))
            .where('fornecedor', '==', Number(this.fornecedor))
            .where('inativo', '==', inativo);
        }
      );
    } else {
      this.produtosClass.snapshot(
        r => {
          return r.where('fornecedor', '==', Number(this.fornecedor))
            .where('inativo', '==', inativo)
            .limit(100);
        }
      );
    }
  }

  ngOnInit() {
    this.form = new FormGroup(
      {
        codigo: new FormControl(0),
        nome: new FormControl(['', [Validators.minLength(10)]]),
        inativo: new FormControl(false),
        precoVenda: new FormControl([0, [Validators.min(0), Validators.max(999999)]]),
        qtdeAtacado: new FormControl([0, [Validators.min(0), Validators.max(999999)]]),
        precoAtacado: new FormControl([0, [Validators.min(0), Validators.max(999999)]]),
        unidade: new FormControl(['PC', [Validators.minLength(2)]]),
        categoria: new FormControl(['', [Validators.minLength(1)]]),
        subCategoria: new FormControl(['', [Validators.minLength(1)]]),
        obs: new FormControl(''),
        reqOrcamento: new FormControl(false),
        prazoEntrega: new FormControl(0),
        estoque: new FormControl(0),
        venderSemEstoque: new FormControl(true),
        img: new FormControl(),
        especificacao: new FormControl(),
        peso: new FormControl(),
        qtdeMin: new FormControl(),
        qtdeMax: new FormControl(),
      }
    );
    this.produtosClass = new Produtos(this.db, this.fornecedor, false);
    this.produtos = [];
    this.produtosEvent = this.produtosClass.changedEvent.subscribe(
      d => {
        console.log(d);
        this.produtos = [];
        d.forEach(element => {
          if (element.imgSrc) { element.img = null; }
        });
          const rt = d.sort(function (a: any, b: any) { return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0); });
          rt.forEach( f => {
            // tslint:disable-next-line:triple-equals
            if (f.fornecedor == this.fornecedor) {
              this.produtos.push(f);
            }
          });
      });

    this.categoriaClass = new Categorias(this.db);
    this.categoriaEvent = this.categoriaClass.changedEvent
      .subscribe(
        d => {
          this.categorias = d.sort(function (a: any, b: any) { return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0); });
          this.categoriasExt = [{ codigo: 0, nome: 'todos' }, ...this.categorias];
        }
      );
    this.categoriaClass.verInativo = false;

    this.subCategClass = new SubCategorias(this.db, null);
    this.subCategEvent = this.subCategClass.changedEvent.subscribe(d => {
      this.subCategorias = d.sort(function (a: any, b: any) { return (a.nome > b.nome) ? 1 : ((b.nome > a.nome) ? -1 : 0); });
    });

   this.abrirProdutos();


  }

  ngOnDestroy() {
    if (this.produtosEvent) {
      this.produtosEvent.unsubscribe();
    }
    if (this.categoriaEvent) {
      this.categoriaEvent.unsubscribe();
    }
    if (this.subCategEvent) {
      this.subCategEvent.unsubscribe();
    }
  }

  get categoriaValue(): number {
    return this.item.categoria;
  }
  set categoriaValue(x: number) {
    if (this.subCategorias.length === 0 || ((this.item.categoria !== undefined) && (x !== this.item.categoria))) {
      this.subCategClass.snapshot(r => {
        return r.where('categoria', '==', Number(x))
          .where('inativo', '==', false);
      });
    }
    this.item.categoria = x;

  }

  @Input()
  get verInativo() {
    return this.produtosClass.verInativo;
  }
  set verInativo(x: boolean) {
    this.produtosClass.fVerInativo = x;
    this.abrirProdutos();
  }
  setFullPath(arq) {
    this.item.img = arq;
  }

  doGerarCodigo(proc?) {
    this.produtosClass.gerarNovoCodigo(
      this.fornecedor,
      r => {
        this.item.codigo = r.valor;
        if (proc) { proc(r); }
      }
    );
  }


  doEditItem(elem) {
    this.oldPageIndex = this.grid.pageIndex;
    super.doEditItem(elem);
    if (this.item.categoria) {
      this.categoriaValue = this.item.categoria; // recarregar sub-categorias
    }
    if (this.inserting && this.item.codigo == null) {
      this.doGerarCodigo();
    }
  }

  add(elem?) {
    super.doNewItem(elem);
    this.item = {};
    this.item.qtdeAtacado = 0;
    this.item.precoAtacado = 0;
    this.item.reqOrcamento = false;
    this.item.unidade = 'PC';
    this.item.prazoEntrega = 0;
    this.item.inativo = false;
    this.item.qtdeMin = 1;
    this.item.qtdeMax = 999;
    this.item.peso = 0;
    this.item.especificacao = '';
    this.doGerarCodigo();
  }
  cancelar() {
    this.editing = false;
    this.pageIndex = this.oldPageIndex;
  }

  private postItem(item) {
    // if (this.inserting)
    // this.item.id = this.item.fornecedor + ':' + this.item.codigo;

    item.regiao = this.fornecedorItem.regiao;
    console.log(this.fornecedorItem, item.regiao);
    const c = item.codigo.toString();
    item.codigo = c;
    this.produtosClass.post(item);
    this.editing = false;
    this.pageIndex = this.oldPageIndex;
  }

  enviar(item) {

    if (item.fornecedor == null) {
      item.fornecedor = this.fornecedor;
    }

    if (item.categoria == null) { item.categoria = 0; }
    if (item.subCategoria == null) {
      item.subCategoria = 0; }

    if (item.codigo == null) {
      this.doGerarCodigo(r => {
        this.postItem(item);
      });
    } else {
      this.postItem(item);
    }
  }

  rowsRefChange(n) {
    this.item.referenciasCount = n;
  }

  getFilterAttrib() {
    return 'ver inativos';
  }

  doCheckFilter(x) {
    this.produtosClass.fVerInativo = x;
    this.abrirProdutos();
  }

  imgPrefix() {
    return 'F' + this.fornecedor + '_';
  }

  selectedImage(event) {
    this.item.img = event;
  }

  uploadMessage(event) {
    if (event.result !== 'ok') {
      this.mensagem = event.message.message_;
      countdown(x => { this.mensagem = ''; }, 1, 30000);
    }
  }

  dataPath(src) {
    this.item.imgSrc = src;
  }
  getImagePath() {
    return this.item.imgSrc;
  }
  getPosition(item) {
    const str = (item.scorePosition ? item.scorePosition : '0:x');
    const r = str.split(':', 1);
    return r[0];
  }

  /*
    @HostListener('paste', ['$event'])
    onPast($event){
      console.log('past',$event);
      retrieveImageFromClipboardAsBlob($event,r=>{
        if (r) {
        console.log( base64.encodeString( r,[] ));
        } else console.log('indefinido');
      })
    }
    */
  colarImage() {

  }

  DoChangeComplementEvent(items: any[]) {
    this.item.complementosCount = items.length;
  }

  DoChangeAdicionaisEvent(items: any[]) {
    this.item.adicionaisCount = items.length;
  }


}
